import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { useCampo } from "../hooks/useCampo";

export function CampoTable({ campos, onSelectCampo, onSuccess }) {
  const { deleteCampo, restoreCampo } = useCampo();

  const handleDeleteCampo = (campo_id, estatus) => {
    Swal.fire({
      icon: "warning",
      title: `${estatus ? "Desactivar" : "Activar"} campo`,
      text: `¿Está seguro que desea ${estatus ? "desactivar" : "activar"} el campo?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: estatus ? "Desactivar" : "Activar",
      cancelButtonText: "Cancelar",
      preConfirm: async () => {
        try {
          if (estatus) {
            await deleteCampo(campo_id);
          }

          if (!estatus) {
            await restoreCampo(campo_id);
          }
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Campo ${estatus ? "desactivado" : "activado"}`,
          timer: 1500,
        });
        onSuccess();
      }
    });
  };

  return (
    <div className="table-responsive" style={{ flex: 1 }}>
      <table className="table table-hover">
        <thead>
          <tr>
            <th>CAMPO</th>
            <th>EN COSECHA</th>
            <th>EXTERNO</th>
            <th>ESTATUS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {campos?.map((item) => (
            <tr key={item.idcampo}>
              <td>{item.campo}</td>
              <td>{item.in_cosecha ? "SI" : "NO"}</td>
              <td>{item.es_externo ? "SI" : "NO"}</td>
              <td>{item.estatus ? "ACTIVO" : "INACTIVO"}</td>
              <td>
                {item.estatus && (
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onSelectCampo(item)}
                  >
                    <FontAwesomeIcon icon="fa-solid fa-pen" />
                  </button>
                )}{" "}
                <button
                  className={
                    item.estatus
                      ? "btn btn-outline-danger btn-sm"
                      : "btn btn-outline-success btn-sm"
                  }
                  onClick={() => handleDeleteCampo(item.idcampo, item.estatus)}
                >
                  <FontAwesomeIcon icon="fa-solid fa-power-off" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
